/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 *
 * https://github.bus.zalan.do/Pegasus/modules/blob/master/packages/abtesting/README.md#cli
 */

import { AssignmentType, createConfig } from '@pegasus/abtesting';

export const { apiPrefix, pendingAssignments, timeout } = createConfig({
    apiPrefix: '/mylounge-api',
    pendingAssignments: [
        {
            // Plus | Plus Eligible EA Campaign card
            alias: 'plus_eligible_ea_campaign_card_v2',
            id: 'a2d9be33-f26c-4d47-a071-4ad1807b9a91',
            defaultVariant: 'ea_twice_a_week_showstopper',
            variants: [
                'ea_twice_a_week_showstopper',
                'daily_ea_campaign_card',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Plus - Daily EA + showstopper position
            id: 'a4167044-44f2-4111-8184-0fd31025b7d6',
            defaultVariant: 'ea_showstopper_position_1',
            variants: [
                'ea_showstopper_position_1',
                'daily_ea_and_position_2',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Brand redesign - Add campaign title to info box - Web
            id: '9df589f0-9668-4a1a-a051-cf499ec1baa8',
            defaultVariant: 'control_campaignTitle',
            variants: [
                'control_campaignTitle',
                'variant_campaignTitle',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Tailor - Removal of Fast Delivery Flag Component
            id: 'e6a406c8-6ca1-41fa-adfd-0a55c93b2760',
            defaultVariant: 'control_fastdelivery_flag',
            variants: [
                'control_fastdelivery_flag',
                'variant_fastdelivery_flag',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Filter campaigns on MyLounge by freshness
            alias: 'Filter_campaigns_freshness',
            id: '9f5fdddb-a00a-4c46-90dd-549515db9661',
            defaultVariant: 'control_CampaignFilter_off',
            variants: [
                'control_CampaignFilter_off',
                'variant_CampaignFilter_on',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // AA Test: Lounge KPI Test
            alias: 'Lounge_AA_KPI_test',
            id: 'eb0e2e53-7935-4b42-bc43-fafb411dd8b6',
            defaultVariant: 'control_aa_test',
            variants: [
                'control_aa_test',
                'variant_aa_test',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Brand Redesign - Fast Delivery Flag
            id: '93655071-a339-4b27-8622-ee2ad9e8a399',
            defaultVariant: 'fast_delivery_flag_control',
            variants: [
                'fast_delivery_flag_control',
                'fast_delivery_flag_variant',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Plus rebranding
            id: '9c895999-c4aa-4642-98ba-1e07d0af8716',
            defaultVariant: 'current_plus_design',
            variants: [
                'current_plus_design',
                'new_plus_design',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Inspire - Get inspired
            id: '93dbf476-f988-4d84-82fd-17b086437a0c',
            defaultVariant: 'control_getinspired_off',
            variants: [
                'control_getinspired_off',
                'variant_getinspired_on',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Plus EA MyLounge Shorter Showstopper 
            id: '3d064362-338a-4cbe-843a-7c238d4572cb',
            defaultVariant: 'old_long_showstopper',
            variants: [
                'old_long_showstopper',
                'shorter_showstopper',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Inspire - Hiding categories info from campaign cards
            id: 'e5b89011-ae1c-47d3-86b6-ddc5df96fb89',
            defaultVariant: 'control_categoriesshown',
            variants: [
                'control_categoriesshown',
                'variant_categorieshidden',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Inspire - Top Header Banner Size decrease
            id: '673eef14-9017-4a5f-bd7e-501f3c94f5f9',
            defaultVariant: 'control_thb_sizeDecrease',
            variants: [
                'control_thb_sizeDecrease',
                'variant_thb_sizeDecrease',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Inspire - THB and Plus with Max width on Desktop 
            alias: 'thb_max_width',
            id: 'ff09baa5-d379-44ff-b46e-f80119a3ea3c',
            defaultVariant: 'control_thb_width',
            variants: [
                'control_thb_width',
                'variant_thb_width',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // GBS - Cross Campaign Filter on Web
            alias: 'ccf-desktop',
            id: 'c1b3d918-3c4e-4ef8-8b84-91ae518fcb93',
            defaultVariant: 'control_ccf_off',
            variants: [
                'control_ccf_off',
                'variant_ccf_on',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Tailor - Omnibus: Change RRP display
            alias: 'omnibus_change_rrp_display',
            id: '61d141a5-6736-4ee7-a7fe-ec4cadee29f9',
            defaultVariant: 'control_RRP_display_off',
            variants: [
                'control_RRP_display_off',
                'variant_RRP_display_on',
            ],
            type: AssignmentType.SERVER,
        },
    ],
    timeout: 200,
});
